import $ from 'jquery';

function WP_EditBar() {
	this.$target = $('.post-content, .news-content');
}

WP_EditBar.prototype.init = function () {
	this.$target.each(function() {
		const self = $(this);
		const editBarTrash = self.find('.edit-bar-trash');

		editBarTrash.on('click submit', function(e) {
			e.preventDefault();

			const _self = $(this);
			var text = $(self, this).find('.title').text();

			if (window.confirm('「'+text+'」の投稿を本当に削除しますか？'))
			{
				_self.find('.fa-spinner').removeClass('hidden');

				var thisParent = $(self, this);
				var trashForm = thisParent.find('form[name="delete-post"]');

				$.ajax({
					type: trashForm.attr('method'),
					url: trashForm.attr('action'),
					data: trashForm.serialize(),
					timeout: 10000,

					beforeSend: function(xhr, settings) {
						_self.attr('disabled', true);
					},
					complete: function(xhr, textStatus) {
						thisParent.delay(500).animate({
							'opacity': 0
						}, 500, function() {
							$(this).remove();
						});
					}
				});
			}
			else
			{
				return;
			}
		});
	});
}

export default WP_EditBar;